import request from '@/utils/request'

// ==================== PLUS会员相关 ====================

/**
 * 计算会员购物车折扣
 */
export function calculateMemberDiscount(data) {
  return request({
    url: '/retail/cashier/calculateDiscount',
    method: 'post',
    data
  })
}

/**
 * 获取会员等级列表
 */
export function listPlusLevel() {
  return request({
    url: '/plus/level/list',
    method: 'get'
  })
}

/**
 * 获取会员等级详情
 */
export function getPlusLevelDetail(levelId) {
  return request({
    url: '/plus/level/detail',
    method: 'get',
    params: { id: levelId }
  })
}

/**
 * 查询会员积分余额
 */
export function getUserScore(userId) {
  return request({
    url: '/retail/cashier/account/score',
    method: 'get',
    params: { userId }
  })
}
